import { render, staticRenderFns } from "./UiPanel.vue?vue&type=template&id=e0cb19a6&scoped=true&"
import script from "./UiPanel.vue?vue&type=script&lang=js&"
export * from "./UiPanel.vue?vue&type=script&lang=js&"
import style0 from "./UiPanel.vue?vue&type=style&index=0&id=e0cb19a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cb19a6",
  null
  
)

export default component.exports